import { generatePath, useParams } from "react-router";

import { LangCode } from "@/lib/gql/__generated__/graphql";
import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { HotelPolicyEditDefaultContainer } from "@/components/features/items/edit/hotel-policy/default/container";

import type { ParamParseKey } from "react-router";

export const HotelPolicyEditPageDefault = () => {
	const { hotelID } = useParams<ParamParseKey<typeof PATHS.HOTEL.HOTEL_SETTINGS.HOTEL_POLICY.TOP>>();
	const activeLangCode = LangCode.Default;

	if (!hotelID) return null;

	const navigator = {
		default: generatePath(PATHS.HOTEL.HOTEL_SETTINGS.HOTEL_POLICY.TOP, { hotelID }),
		i18n: (langCode: LangCode) => generatePath(PATHS.HOTEL.HOTEL_SETTINGS.HOTEL_POLICY.I18N, { hotelID, langCode }),
	};

	return (
		<PageMeta title="ホテルポリシー" url={generatePath(PATHS.HOTEL.HOTEL_SETTINGS.HOTEL_POLICY.TOP, { hotelID })}>
			<HotelPolicyEditDefaultContainer hotelID={hotelID} activeLangCode={activeLangCode} navigator={navigator} />
		</PageMeta>
	);
};

HotelPolicyEditPageDefault.displayName = "HotelPolicyEditPageDefault";
